import AdminGuard from "helpers/AuthType/AdminGuard";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Input,
    Button
} from "reactstrap";

const walkingOptions = [
    { value: 101, label: "Walking #101 - Builder A" },
    { value: 102, label: "Walking #102 - Builder B" }
];

const likeOptions = [
    { value: "location", label: "Location" },
    { value: "pricing", label: "Pricing" },
    { value: "design", label: "Design" },
    { value: "amenities", label: "Amenities" },
    { value: "connectivity", label: "Connectivity" }
];

const dislikeOptions = [
    { value: "price", label: "High Price" },
    { value: "distance", label: "Far from city" },
    { value: "traffic", label: "Traffic" },
    { value: "construction", label: "Construction Quality" },
    { value: "layout", label: "Layout" }
];

const FeedbackForm = () => {
    const [formData, setFormData] = useState({
        walking_id: null,
        experience: "",
        likes: [],
        dislikes: [],
        custom_likes: "",
        custom_dislikes: "",
        rating: 0,
        status: "Follow-up"
    });
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSelect = (name, value) => {
        setFormData({ ...formData, [name]: value || [] });
    };

    const setRating = (value) => {
        setFormData({ ...formData, rating: value });
    };

    const validateForm = () => {
        return (
            formData.walking_id &&
            formData.experience &&
            formData.rating > 0
        );
    };

    const SubmitFeedback = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please complete all mandatory fields");
            return;
        }

        const payload = {
            walking_id: formData.walking_id.value,
            experience: formData.experience,
            likes: [
                ...formData.likes.map(l => l.value),
                formData.custom_likes
            ].filter(Boolean),
            dislikes: [
                ...formData.dislikes.map(d => d.value),
                formData.custom_dislikes
            ].filter(Boolean),
            rating: formData.rating,
            status: formData.status,
            submitted_at: new Date().toISOString()
        };

        console.log("FEEDBACK PAYLOAD:", payload);
        toast.success("Feedback saved successfully!");
        // 🔜 API CALL HERE
    };

    const selectStyle = {
        control: (base) => ({
            ...base,
            background: "rgba(255,255,255,0.15)",
            borderColor: "rgba(255,255,255,0.3)",
            color: "#fff"
        }),
        singleValue: (base) => ({ ...base, color: "#fff" }),
        menu: (base) => ({ ...base, background: "#1E253A" }),
        option: (base, state) => ({
            ...base,
            background: state.isFocused ? "#6f42c1" : "#1E253A",
            color: "#fff"
        })
    };

    return (
        <AdminGuard>
            <React.Fragment>
                <ToastContainer />
                <div className="page-content" style={{ color: "#fff" }}>
                    <Container fluid className="py-2">
                        <Row className="justify-content-center">
                            <Col xl={12}>
                                <Card
                                    style={{
                                        background: "rgba(30,37,58,0.95)",
                                        borderRadius: "16px",
                                        border: "1px solid rgba(255,255,255,0.2)"
                                    }}
                                >
                                    <CardBody>
                                        {/* <CardTitle className="h3 mb-4">
                                            <i className="bx bx-message-square-detail me-2" />
                                            Visitor Feedback
                                        </CardTitle> */}

                                        <div
                                            className="d-flex align-items-center justify-content-between mb-4"
                                        >
                                            <CardTitle className="h3 mb-0">
                                                <i className="bx bx-walk me-2" />
                                                Visitor Feedback
                                            </CardTitle>

                                            <Button
                                                size="sm"
                                                onClick={() => navigate(-1)}
                                                style={{
                                                    background: "rgba(255,255,255,0.1)",
                                                    border: "1px solid rgba(255,255,255,0.3)",
                                                    borderRadius: "10px",
                                                    color: "#fff",
                                                    padding: "6px 14px",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                    transition: "all 0.2s ease"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = "#6f42c1";
                                                    e.currentTarget.style.boxShadow =
                                                        "0 0 12px rgba(111,66,193,0.7)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background =
                                                        "rgba(255,255,255,0.1)";
                                                    e.currentTarget.style.boxShadow = "none";
                                                }}
                                            >
                                                <i className="bx bx-arrow-back" />
                                                Back
                                            </Button>
                                        </div>


                                        <form>
                                            {/* Walking */}
                                            <Row>
                                                <Col md={4}>
                                                    <Label>Select Walking *</Label>
                                                    <Select
                                                        options={walkingOptions}
                                                        styles={selectStyle}
                                                        placeholder="Select Walking"
                                                        onChange={(val) =>
                                                            setFormData({ ...formData, walking_id: val })
                                                        }
                                                    />
                                                </Col>
                                            </Row>

                                            {/* Experience */}
                                            <Row className="mt-3">
                                                <Col md={8}>
                                                    <Label>Visitor Experience *</Label>
                                                    <Input
                                                        type="textarea"
                                                        name="experience"
                                                        rows="4"
                                                        placeholder="Describe visitor's overall experience..."
                                                        onChange={handleChange}
                                                        style={{
                                                            background: "rgba(255,255,255,0.15)",
                                                            color: "#fff",
                                                            border: "1px solid rgba(255,255,255,0.2)"
                                                        }}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* Likes / Dislikes */}
                                            <Row className="mt-3">
                                                <Col md={4}>
                                                    <Label>Likes</Label>
                                                    <Select
                                                        isMulti
                                                        options={likeOptions}
                                                        styles={selectStyle}
                                                        placeholder="What they liked"
                                                        onChange={(val) => handleSelect("likes", val)}
                                                    />
                                                    <Input
                                                        className="mt-2"
                                                        placeholder="Other likes..."
                                                        name="custom_likes"
                                                        onChange={handleChange}
                                                        style={{
                                                            background: "rgba(255,255,255,0.15)",
                                                            color: "#fff",
                                                            border: "1px solid rgba(255,255,255,0.2)"
                                                        }}
                                                    />
                                                </Col>

                                                <Col md={4}>
                                                    <Label>Dislikes</Label>
                                                    <Select
                                                        isMulti
                                                        options={dislikeOptions}
                                                        styles={selectStyle}
                                                        placeholder="What they disliked"
                                                        onChange={(val) => handleSelect("dislikes", val)}
                                                    />
                                                    <Input
                                                        className="mt-2"
                                                        placeholder="Other dislikes..."
                                                        name="custom_dislikes"
                                                        onChange={handleChange}
                                                        style={{
                                                            background: "rgba(255,255,255,0.15)",
                                                            color: "#fff",
                                                            border: "1px solid rgba(255,255,255,0.2)"
                                                        }}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* Rating + Status */}
                                            <Row className="mt-3">
                                                <Col md={4}>
                                                    <Label>Overall Rating *</Label>
                                                    <div>
                                                        {[1, 2, 3, 4, 5].map((num) => (
                                                            <i
                                                                key={num}
                                                                className={`bx ${num <= formData.rating
                                                                    ? "bxs-star"
                                                                    : "bx-star"
                                                                    }`}
                                                                style={{
                                                                    fontSize: "26px",
                                                                    color: "#ffc107",
                                                                    cursor: "pointer",
                                                                    marginRight: "6px"
                                                                }}
                                                                onClick={() => setRating(num)}
                                                            />
                                                        ))}
                                                    </div>
                                                </Col>

                                                <Col md={4}>
                                                    <Label>Status of Walking</Label>
                                                    <Input
                                                        type="select"
                                                        name="status"
                                                        onChange={handleChange}
                                                        style={{
                                                            background: "rgba(255,255,255,0.15)",
                                                            color: "#fff",
                                                            border: "1px solid rgba(255,255,255,0.2)"
                                                        }}
                                                    >
                                                        <option style={{ color: "#000" }} value="Converted">Converted</option>
                                                        <option style={{ color: "#000" }} value="Follow-up">Follow-up</option>
                                                        <option style={{ color: "#000" }} value="Dropped">Dropped</option>
                                                    </Input>

                                                </Col>
                                            </Row>

                                            <div className="d-flex justify-content-end mt-4">
                                                <Button
                                                    onClick={SubmitFeedback}
                                                    style={{
                                                        background: "#6f42c1",
                                                        border: "none",
                                                        borderRadius: "12px",
                                                        padding: "10px 30px",
                                                        fontSize: "16px"
                                                    }}
                                                >
                                                    <i className="bx bx-save me-1" />
                                                    Submit Feedback
                                                </Button>
                                            </div>
                                        </form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        </AdminGuard>
    );
};

export default FeedbackForm;
